import { render } from "./HoverWrapper.vue?vue&type=template&id=6f4fbf78&scoped=true"
import script from "./HoverWrapper.vue?vue&type=script&lang=js"
export * from "./HoverWrapper.vue?vue&type=script&lang=js"

import "./HoverWrapper.vue?vue&type=style&index=0&id=6f4fbf78&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4fbf78"]])

export default __exports__